export default __webpack_public_path__ + "static/media/not-reacted.7107ce9f.svg";